import {TransactionSearch} from "./TransactionSearch";

export function AccountFraudDetail() {
    return (
        <section>
            <div className="ui container">
                <div className="segment">
                    <div className="ui">
                        <TransactionSearch/>
                    </div>
                </div>
            </div>
        </section>
        );
}